import { tidalColorsDark } from "./tidalColorsDark.js";
import { tidalColorsLight } from "./tidalColorsLight.js";
function createTidalColorPalettes() {
  return { tidalColorsLight, tidalColorsDark };
}
export {
  createTidalColorPalettes
};
//# sourceMappingURL=createTidalColorPalettes.js.map
